import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AgreementService } from '../_services/';
import { AppState } from '../../reducers';
import {
  ClearContactRelationshipAgreementErrors,
  ContactRelationshipAgreementActionToggleLoading,
  ContactRelationshipAgreementActionTypes,
  ContactRelationshipAgreementsPageCancelled,
  ContactRelationshipAgreementsPageLoaded,
  ContactRelationshipAgreementsPageRequested,
  ContactRelationshipAgreementsPageToggleLoading,
  ThrowContactRelationshipAgreementError,
} from '../_actions/contact-relationship-agreements.actions';

@Injectable()
export class ContactRelationshipAgreementEffects {
  showPageLoadingDistpatcher = new ContactRelationshipAgreementsPageToggleLoading({
    isLoading: true,
  });
  hideLoadingDistpatcher = new ContactRelationshipAgreementsPageToggleLoading({ isLoading: false });
  showActionLoadingDistpatcher = new ContactRelationshipAgreementActionToggleLoading({
    isLoading: true,
  });
  hideActionLoadingDistpatcher = new ContactRelationshipAgreementActionToggleLoading({
    isLoading: false,
  });

  constructor(
    private actions$: Actions,
    private agreementsService: AgreementService,
    private store: Store<AppState>,
  ) {}

  @Effect()
  loadContactRelationshipAgreementsPage$ = this.actions$.pipe(
    ofType<ContactRelationshipAgreementsPageRequested>(
      ContactRelationshipAgreementActionTypes.ContactRelationshipAgreementsPageRequested,
    ),
    mergeMap(({ payload }) => {
      return this.agreementsService.findByEntityContact(payload.contactId, payload.entityId).pipe(
        catchError((error) => of({ error })),
        map((res) => {
          if (res.error) {
            this.store.dispatch(new ThrowContactRelationshipAgreementError({ error: res }));
            return new ContactRelationshipAgreementsPageCancelled();
          }

          this.store.dispatch(new ClearContactRelationshipAgreementErrors());

          return new ContactRelationshipAgreementsPageLoaded({
            contactRelationshipAgreements: res.data,
            totalCount: res.data.length,
          });
        }),
      );
    }),
  );
}
